var dd = require('react-dd');
var dd = dd;
var FormInputMixin = require('../FormInputMixin');

var component = dd.createClass({
	mixins: [FormInputMixin],
	__onChange: function(e){
		this._input_newValue(!!e.target.checked);
	},
	render: function(){
		var field = this.props.field;
		var value = this.props.value;

		return dd.label({className: "forms-checkbox", style: {fontWeight: 'normal'}},
			dd.input({type: 'checkbox', checked: !!value, name: this.props.field_path, onChange: this.__onChange, disabled: field.read_only ? 'disabled' : null}),
			' ',
			field.label
		);
	}
});

module.exports = {
	component: component,
	validate: function(){
		return true;//can't go wrong with a checkbox
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/inputs/Checkbox.js
// module id = 192
// module chunks = 0 1 2 3 4